import React from "react";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";

import { useTimeZoneStore } from "../../stores/timeZone";

import SoftBox from "../../components/SoftBox";

/** Shared portal footer with the reference branding and timezone note. */
function Footer() {
  const timeZone = useTimeZoneStore((state) => state.timeZone);
  return (
    <SoftBox
      component="footer"
      sx={({ palette }) => ({
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1.5,
        mt: 2.875,
        color: palette.text.secondary,
        fontSize: { xs: 11, sm: 12 },
        lineHeight: 1.5,
        "& > span": {
          display: "inline-flex",
          alignItems: "center",
          gap: 0.75,
          whiteSpace: "nowrap",
        },
        "& > span:last-child": {
          whiteSpace: "normal",
          overflowWrap: "anywhere",
        },
        "& strong": {
          color: palette.dark.main,
          fontSize: 13,
          letterSpacing: "-0.04em",
        },
      })}
    >
      <span>
        Payments powered by <strong>CyberPay</strong>
      </span>
      <span>
        <GppGoodOutlinedIcon sx={{ fontSize: 14, flexShrink: 0 }} />
        Your business. In good hands.
      </span>
      <span>All times in {timeZone.replace(/_/g, " ")}</span>
    </SoftBox>
  );
}

export default Footer;
